import { Component, OnInit } from '@angular/core';

import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';

export class BaseColumnSelectComponent {
    public projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;

    public selectColumn(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        for (var i = 0; i < this.columns.length; ++i) {
            this.columns[i].isSelected = false;
        }
        column.isSelected = true;
        this.selectedColumn = column;
    }

    public displayRoughNum(num: number): string {
        if(num < 100) {
            return `${num} values`;
        }
        if(num < 200) {
            return `> 100`;
        }
        if(num < 400) {
            return `> 200`;
        }
        if(num <= 1000) {
            return `> 400`;
        }
        return `> 1000`;
    }
}
